import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/notification-schema'
const { notificationSchema: schema } = schemaSettings
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'
import * as yup from 'yup'

const service = apiClient.service('notifications')
const recipientsService = apiClient.service('notifications/recipients')

export default ({ name }) => ({
  state: {
    ...createCrudState({ entityType: 'notifications', storePrefix: name }),
    recipientCount: 0,
  },
  sequences,
  providers: {
    ...createProviders({ name, service, schema }),
    ...createProviders({ name: 'recipients', service: recipientsService, schema: yup.object() }),
  },
  catch: [
    redirectUnauthorized(),
    [
      Error,
      showFeedbackFromError({ title: 'We encountered an error' }),
      ({ props: { error, errorPath = name }, store }) => {
        store.set(state`errors.${errorPath}`, error)
      },
    ],
  ],
})
